import { userProfile } from "./UserProfile";

const ft_lambda_url = process.env.REACT_APP_COPILOT_API_BASE;

const userCache = userProfile(localStorage);

const BizdevAgentUrl = (path) => {
  return `${ft_lambda_url}${path}`;
};

const BizdevAgentEndpoint = {
  async getBizdevAgentData(type) {
    const userId = userCache.userId();
    const response = await fetch(
      BizdevAgentUrl(
        `/bizdev/details/${encodeURIComponent(userId)}?type=${type}`
      )
    );
    // console.log("response", response);
    if (!response.ok) {
      throw new Error("Failed to fetch user data");
    }
    const data = await response.json();
    // console.log("response", data);
    return data;
  },
  async getRateLimitInfo() {
    const userId = userCache.userId();
    const response = await fetch(BizdevAgentUrl(`/bizdev/check/${userId}`));
    // console.log("response", response);
    if (!response.ok) {
      throw new Error("Failed to fetch user data");
    }
    const data = await response.json();
    // console.log("response", data);
    return data;
  },
};

export default BizdevAgentEndpoint;
